module.exports = __webpack_public_path__ + "img/fji.60620e85.svg";